import React from "react";
import { OfferPerPromoQuery } from "types/graphql-types";
import {
  HeroBanner,
  SectionContainer
} from "@silversea-ssc/ui-components-react";
import { IntroButtons } from "./IntroButtons";
import CallOurReservationTeam from "components/CallOurReservationTeam/CallOurReservationTeam";
import * as styles from "./OffersPerPromo.module.scss";
import { offerNotAvailable } from "./helpers";

type NonNullableOfferPerPromoQuery = {
  offer: NonNullable<OfferPerPromoQuery["offer"]>;
  raqPagePath: string | undefined;
};

const OfferPerPromoNotActive: React.FC<
  React.PropsWithChildren<NonNullableOfferPerPromoQuery>
> = ({ offer, raqPagePath }) => {
  return (
    <React.Fragment>
      <HeroBanner background={offer.heroImage} size="compact" />
      <SectionContainer
        spacingTop="regular"
        spacingBottom={null}
        dataContentName="offer_title"
      >
        {offerNotAvailable()}
      </SectionContainer>

      <SectionContainer
        spacingTop="regular"
        spacingBottom="regular"
        dataContentName="offer_details"
      >
        <IntroButtons raqURL={raqPagePath} offer={offer} />

        <CallOurReservationTeam
          className={styles.callReservationTeam}
          prefixOr
        />
      </SectionContainer>
    </React.Fragment>
  );
};

export default React.memo(OfferPerPromoNotActive);
